import { AxiosInstance } from "axios";
import { Method, Resource } from "../Resource";

export type TeamMember = {
  id: string;
  firstName: string;
  lastName: string;
  role: string;
  createdAt: string;
};

export class TeamMembers extends Resource<TeamMember> {
  constructor(axiosInstance: AxiosInstance) {
    super("teamMembers", axiosInstance);
  }

  public async get(id: string): Promise<TeamMember> {
    return this.request({ method: Method.GET, path: id });
  }

  public async list({
    page,
    pageSize
  }: {
    page?: number;
    pageSize?: number;
  } = {}): Promise<TeamMember[]> {
    const { items: teamMembers } = await this.request({
      method: Method.GET,
      query: { page, pageSize }
    });

    return teamMembers;
  }
}
